import React from 'react';
import MaterialIcon, {colorPalette} from 'material-icons-react';

import './SliderViewPageDetail.css'
import RowContainer from './RowContainer';
import DropArea from '../DropArea';
import { RenderComponentDropArea } from '../ComponentDropArea';
import { allowed_types_component_without_group, allowed_types_component_menu_without_group } from './DropContext';

const SliderViewPageDetail = (props) => {
  // values
  const { 
    component, 
    message_index, 
    row_index,
    isDragging,
    messageActions,
    editing_message_index,
    editing_row_index,
    editing_slide_page_index,
  } = props
  console.log('isDragging :', isDragging);
  console.log('messageActions from SliderViewPageDetail :', messageActions);
  // methods
  const { 
    completeSlidePageDetail, 
    quitSlidePageDetail, 
    deleteSlidePage, 
    onDropInitArea
  } = props
  console.log('component :', component);
  const { rows } = component
  console.log('rows :', rows);
  /**
   * 뒤로가기버튼 onClick
   * @param {Object} e 
   */
  const handleClickBackBtn = (e) => {
    quitSlidePageDetail()
  }

  /**
   * 완료버튼 onClick
   * @param {Object} e 
   */
  const handleClickCompleteBtn = (e) => {
    completeSlidePageDetail()
  }

  /**
   * 삭제버튼 onClick
   * @param {Object} e 
   */
  const handleClickDeleteBtn = (e) => {
    if (window.confirm('삭제한 후 되돌릴 수 없습니다. 삭제하시겠습니까?')) { 
      deleteSlidePage()
    }
  }

  /**
   * Init component drop area `onDrop` handler
   * @param {Object} e 
   */
  const handleOnDropInitArea = (e) => {
    
    onDropInitArea(e)
  }

  console.log('SliderViewPageDetail - render()')
  console.log('props.component.rows :', props.component.rows);

  return (
    <div id='page-detail'>
      <div class='left-area'>
        <button id='back-btn' onClick={handleClickBackBtn} title="돌아가기">
          {/* arrow_back_ios */}
          <MaterialIcon icon='arrow_back_ios' size='medium' />
        </button>
        <button id='edit-btn' onClick={handleClickCompleteBtn}>
          완료
        </button>
        <button id='delete-btn' onClick={handleClickDeleteBtn}>
          삭제
        </button>
      </div>
      <div class='right-area'>
        <div class='edit-area'>
          {
            rows && rows.length <= 0 ? (
              <RenderComponentDropArea
                key={'init_comp_drop_area'}
                onDrop={handleOnDropInitArea}
                DnDOverContent={null}
                overContentArg={{minHeight: 295}} // minus border (2.5px)
                allowed_types={[...allowed_types_component_menu_without_group, ...allowed_types_component_without_group]} // Availiable list: 'Components from menu', 'In slide page components'
                customStyle={{
                  opacity: 1,
                  minHeight: 300,
                  border: '2.5px dashed grey',
                  borderStyle: 'dashed',
                  borderRadius: '10px',
                }}
              /> 
            ) : (
              rows.map((row, i) => (
                <RowContainer key={i} 
                  isDragging={isDragging}
                  row={row} 
                  message_index={message_index} 
                  row_index={row_index} 
                  isFirstRow={i === 0}
                  editing_message_index= {editing_message_index}
                  editing_row_index= {editing_row_index}
                  editing_slide_page_index= {editing_slide_page_index}
                  editingRowIndex={i+1} 
                  messageActions={messageActions}
                />
              ))
            )
          }
        </div>
      </div>
    </div>
  )
}

export default SliderViewPageDetail